module.exports = __webpack_public_path__ + "static/media/image-pet.a9db8126.png";